<template>
  <div>
    <div>
      <div class="title">{{ arr }}</div>
      <ul v-if="guanzhu.length">
        <li v-for="item in guanzhu" :key="item.id">
          <div class="djimg" @click="other(item)">
            <img
              :src="item.space_avatar"
              alt=""
              v-if="item.space_avatar != ''"
            />
            <img
              src="http://rjwpublic.oss-cn-qingdao.aliyuncs.com/album/beijingtupian.jpg"
              alt=""
              v-else
            />
          </div>
          <div>
            <p class="djimg" @click="other(item)">{{ item.space_name }}</p>
            <p>
              简介：
              <span v-if="item.space_brief != ''">{{ item.space_brief }}</span>
              <span v-else>这位老师有点懒！！！</span>
            </p>
            <div>
              <span>粉丝 {{ item.fanse_num }}</span>
              <span>|</span>
              <span>动态 {{ item.dynamics_num }}</span>
              <span
                @click="guanzhuqh(item)"
                :class="{ actives: item.is_follow == 1 }"
              >
                {{ item.is_follow == 0 ? "关注" : "已关注" }}
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div v-else>
        <Zanwu></Zanwu>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "../../api/index";
import axios from "axios";
import Zanwu from "../../components/common/zanwu";
export default {
  data() {
    return {
      arr: "我的关注",
      UserInfo: "",
      getSpaceinfo: "",
      guanzhu: "",
    };
  },
  components: {
    Zanwu,
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.guan_zhu();
  },
  methods: {
    other(e) {
      if (this.getSpaceinfo.space_id == e.space_id) {
        this.$router.push("/space/saying");
        return false;
      }
      localStorage.setItem("iteminfo", JSON.stringify(e));
      if (this.$route.path == "/space/saying") {
        this.reload();
      } else {
        this.$router.push("/space/saying");
      }
    },

    //关注
    guan_zhu() {
      var that = this;
      var getMyFollowSpace_data = {
        token: that.UserInfo.token,
        page_num: 100,
      };
      // 获取关注列表
      this.$post(URL.getMyFollowSpace, getMyFollowSpace_data).then((res) => {
        that.guanzhu = res.result.pace_list;
      });
    },
    // 取消关注数据上报
    getRecordRjw(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_attentioncancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark:
            `${hh.user_nicename}` + "使用了网络学习空间的关注的取消关注功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            unfollow_id: row.space_id,
            unfollow_name: row.space_name,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    guanzhuqh(e) {
      // console.log(e);
      this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")), e);
      e.is_follow = e.is_follow == "0" ? "1" : "0";
      if (e.is_follow == "1") {
        var addMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 关注空间
        this.$post(URL.addMyFollowSpace, addMyFollowSpace_data).then(
          (res) => {}
        );
      } else if (e.is_follow == "0") {
        var delMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 取消关注空间
        this.$post(URL.delMyFollowSpace, delMyFollowSpace_data).then((res) => {
          if (res.state == 0) {
            this.guan_zhu();
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.djimg {
  cursor: pointer;
}
.title {
  background-color: #fff;
  // margin-top: 12px;
  padding-left: 16px;
  margin-bottom: 15px;
  line-height: 50px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #4b4b4b;
}
ul {
  overflow: hidden;
  padding: 1px;
  padding-left: 20px;
  li {
    float: left;
    margin-right: 36px;
    width: 372px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(69, 69, 69, 0.14);
    //     display: none;
    margin-bottom: 25px;
    div {
      display: inline-block;
      &:first-child {
        float: left;
        img {
          width: 120px;
          height: 120px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      &:nth-child(2) {
        float: right;
        width: 65%;
        p {
          &:first-child {
            font-size: 16px;
            color: #4b4b4b;
            line-height: 34px;
          }
          &:nth-child(2) {
            font-size: 14px;
            line-height: 22px;
            margin: 5px 0;
            color: #898989;
            min-height: 46px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
          }
        }
        & > div {
          width: 100%;
          line-height: 30px;
          font-size: 12px;
          color: #3c495c;
          position: relative;
          span {
            &:nth-child(2) {
              margin: 0 15px;
            }
            &:last-child {
              display: inline-block;
              width: 4em;
              font-size: 14px;
              text-align: center;
              line-height: 26px;
              margin: auto;
              border-radius: 5px;
              border: 1px solid #409eff;
              color: #409eff;
              position: absolute;
              top: 50%;
              right: -8%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.actives {
  background-color: #eee;
  border: none !important;
  color: #000 !important;
}
.act {
  display: block;
}
</style>
